import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="review-toggle"
// Handles toggling review sections with arrow rotation
export default class extends Controller {
  static values = {
    groupNumber: String
  }

  connect() {
    // The controller is connected to the clickable container
  }

  toggle(event) {
    event.preventDefault()

    const group = this.groupNumberValue
    const contentElement = document.getElementById(`review-lists-${group}-yash`)
    const arrowElement = document.getElementById(`arrow-${group}-yash`)

    if (!contentElement || !arrowElement) {
      console.warn(`Could not find elements for group ${group}`)
      return
    }

    const isOpened = arrowElement.getAttribute("data-opened") === "true"
    let transformDegree = 0

    if (!isOpened) {
      transformDegree = -180
      arrowElement.setAttribute("data-opened", "true")
      window.$(contentElement).slideDown(200)
    } else {
      arrowElement.setAttribute("data-opened", "false")
      window.$(contentElement).slideUp(200)
    }

    arrowElement.style.webkitTransform = `rotate(${transformDegree}deg)`
    arrowElement.style.transform = `rotate(${transformDegree}deg)`
  }

  // No-op action used to attach :stop modifier to prevent event bubbling
  // Used by Quiz/Game/Comp Central buttons to prevent toggle when clicked
  preventBubble() {
    // Intentionally empty - the :stop modifier handles stopPropagation
  }
}
